// adminportal/src/app/terms/terms.component.ts

import {
  Component,
  EventEmitter,
  Output,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Config } from '../../models/config.model';
import { NgxPrintService } from 'ngx-print';
import { PrintOptions } from 'ngx-print';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SharedDataService } from 'src/app/services/shared-data.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
})
export class TermsComponent {
  @Output() accept: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('terms') terms: ElementRef;
  @ViewChild('modalContent') modalContent: ElementRef;

  config: Config | null;

  isModalOpen: boolean = false;
  rejected: boolean = false;

  isButtonDisabled = true;

  constructor(
    private sanitizer: DomSanitizer,
    private printService: NgxPrintService,
    private deviceService: DeviceDetectorService,
    private sharedDataService: SharedDataService
  ) {}

  @HostListener('window:resize', ['$event'])

  ngOnInit(): void {
    this.sharedDataService.getConfig().subscribe(config => this.config = config);
  }


  onResize(event: any): void {
    this.checkScroll();
  }

  onScroll(): void {
    this.checkScroll();
  }

  checkScroll(): void {
    if (!this.terms) return;
    const element = this.terms.nativeElement;
    const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 1;
    if (atBottom) {
      this.isButtonDisabled = false;
    }
  }

  toggleModal(appearAtYCoordinate: number = 0) {
    this.isModalOpen = !this.isModalOpen;
    if (this.isModalOpen) {
      this.focusTerms();
      if (this.modalContent && this.modalContent.nativeElement) {
        const modalContentElement = this.modalContent.nativeElement as HTMLElement;
        modalContentElement.style.top = `${appearAtYCoordinate}px`;
      }
    }
  }



  focusTerms() {
    const that = this;
    setTimeout(() => {
      if (that.terms && that.terms.nativeElement) {
        that.terms.nativeElement.focus();
      }
    }, 700);
  }

  termsText() {
    const htmlContent = this.config.terms.text;
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }

  rejectWarning() {
    const htmlContent = this.config.terms.rejectWarning;
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }

  onAccept() {
    this.isModalOpen = false;
    this.rejected = false;
    this.accept.emit(true);
  }

  onReject() {
    this.rejected = true;
    this.accept.emit(false);
  }

  onPrint(): void {
    const isDesktopDevice = this.deviceService.isDesktop();
    const customPrintOptions: PrintOptions = new PrintOptions({
      printSectionId: 'print-section',
      closeWindow: isDesktopDevice,
      openNewTab: false
    });
    this.printService.print(customPrintOptions);
  }

  onClose() {
    this.isModalOpen = false;
  }
}
